import { useUser } from 'hooks/useUser';

export const useUserPartnerBalance = (): number => {
  const user = useUser();

  if (user?.partnerFinances) {
    return user.partnerFinances.balanceAmount;
  }

  return 0;
};
